import { ArrowRight } from "lucide-react";

/**
 * Signature OZ WASTE brand moment. Deliberately minimal: three words per line,
 * black background, orange accent. Sits directly after the services grid.
 */
const BrandStatement = () => (
  <section className="relative overflow-hidden bg-[#111111] py-20 md:py-28">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_75%_20%,rgba(246,74,1,0.22),transparent_60%)]"
    />
    <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-[#FDC00E] via-orange to-[#FDC00E]" />
    <div className="container relative z-10 text-center">
      <h2 className="text-4xl sm:text-5xl md:text-7xl font-black leading-[0.95] tracking-tight text-white">
        YOU POINT.
        <br />
        WE LOAD.
        <br />
        <span className="text-orange">IT'S GONE.</span>
      </h2>
      <p className="mt-6 text-white/70 text-base md:text-lg font-medium">
        No skip to load. No heavy lifting. No rubbish left behind.
      </p>
      <a
        href="/#quote"
        className="mt-10 inline-flex items-center justify-center gap-2 bg-orange text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange-deep transition-colors"
      >
        Get a Free Quote
        <ArrowRight className="w-5 h-5 shrink-0" />
      </a>
    </div>
  </section>
);

export default BrandStatement;
